module.exports = __webpack_public_path__ + "static/media/YM34_0.82d69973.jpg";